/**
 * Whether a newer build has been observed since this tab loaded.
 *
 * Its own module so `buildUpdate` (which sets it and reports analytics) and `googleAnalytics`
 * (which tags every error with it) do not have to import each other.
 */
let newBuildAvailable = false;

export function isNewBuildAvailable(): boolean {
  return newBuildAvailable;
}

export function markNewBuildAvailable(): void {
  newBuildAvailable = true;
}
